import { extendTheme } from "@chakra-ui/react";

// https://chakra-ui.com/docs/theming/theme
export const theme = extendTheme({
  fonts: {
    body: "Virgil, system-ui, sans-serif",
    // heading: "Georgia, serif",
  },
  styles: {
    global: {
      "html, body, #root": {
        height: "100%",
      },
    },
  },
});
